import React from 'react';
import styled from 'styled-components';
import { FaChevronRight, FaRupeeSign } from 'react-icons/fa';
import { FaClock, FaBuilding } from 'react-icons/fa'; // Icons for courts and time
import { Link } from 'react-router-dom';

const PopularCourtsContainer = styled.div`
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  margin-top: 1rem;
  overflow: hidden;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

const Title = styled.h2`
  font-size: 1.2rem;
  color: #263238;
  font-weight: bold;
`;

const SliderIcon = styled(FaChevronRight)`
  color: #66bb6a;
  font-size: 1.5rem;
  cursor: pointer;
  transition: color 0.3s;

  &:hover {
    color: #388e3c;
  }
`;

const CourtsSlider = styled.div`
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  padding-top: 0.5rem;
  max-width: 100%;
  scroll-snap-type: x mandatory; /* Enables smooth scrolling effect on supported browsers */
`;

const CourtCard = styled.div`
  min-width: 300px; /* Increase to ensure overflow */
  width: 300px;
  height: 350px;
  background-color: #f8f8f8;
  border-radius: 15px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CourtImage = styled.img`
  width: 100%; /* Make image take full width of the card */
  height: 200px; /* Adjust height as needed */
  object-fit: cover;
  border-radius: 10px;
`;

const InfoOverlay = styled.div`
  position: absolute;
  bottom: 15px;
  left: 10px;
  color: #ffffff;
  font-size: 0.8rem;
  display: flex;
  gap: 10px;
  align-items: center;
`;

const PriceTag = styled.div`
  background-color: #ffc107;
  padding: 0.3rem 0.6rem;
  color: white;
  font-weight: bold;
  font-size: 0.8rem;
  border-radius: 10px;
  position: absolute;
  top: 10px;
  right: 10px;
`;

const CourtDetails = styled.div`
  padding: 0.5rem 0;
  text-align: center;
`;

const CourtName = styled.h3`
  font-size: 1rem;
  color: #263238;
  margin: 0.5rem 0;
  font-weight: bold;
`;

const CourtLocation = styled.p`
  font-size: 0.8rem;
  color: #757575;
`;

const PopularCourts = () => {
  const courts = [
    {
      id: 1,
      name: 'Global Bamindton Academy',
      location: 'Melvisharam',
      price:  `₹ 100 / Hour`,
      img: '/images/court.png',
      courts: 2,
      time: '9 AM - 10 PM',
    },
    {
        id: 1,
        name: 'Global Bamindton Academy',
        location: 'Melvisharam',
        price: `₹ 100 / Hour`,
        img: '/images/court1.png',
        courts: 2,
        time: '9 AM - 10 PM',
      },
      {
        id: 1,
        name: 'Global Bamindton Academy',
        location: 'Melvisharam',
        price: `₹ 100 / Hour`,
        img: '/images/court1.png',
        courts: 2,
        time: '9 AM - 10 PM',
      },
      {
        id: 1,
        name: 'Global Bamindton Academy',
        location: 'Melvisharam',
        price: `₹ 100 / Hour`,
        img: '/images/court.png',
        courts: 2,
        time: '9 AM - 10 PM',
      },
    // Add more courts as needed
  ];

  return (
    <PopularCourtsContainer>
      <HeaderWrapper>
        <Title>Most Popular</Title>
        <SliderIcon />
      </HeaderWrapper>
      <CourtsSlider>
        {courts.map((court) => (
          <Link to="/booking">
          <CourtCard key={court.id}>
            <div style={{ position: 'relative' }}>
              <CourtImage src={court.img} alt={court.name} />
              <PriceTag>{court.price}</PriceTag>
              <InfoOverlay>
                <span><FaBuilding /> Courts: {court.courts}</span>
                <span><FaClock /> {court.time}</span>
              </InfoOverlay>
            </div>
            <CourtDetails>
              <CourtName>{court.name}</CourtName>
              <CourtLocation>{court.location}</CourtLocation>
            </CourtDetails>
          </CourtCard>
          </Link>
        ))}
      </CourtsSlider>
    </PopularCourtsContainer>
  );
};

export default PopularCourts;
